import React from "react";
import { connect } from "react-redux";
import PageHeaderWrapper from "../../components/PageHeaderWrapper";
import { Card, Spin, Descriptions, Row, Col, Icon, Avatar, Tag, Badge, Button, Tooltip, notification } from "antd";
import Autosuggest from "react-autosuggest";
import moment from "moment";
import Request, { MEDIA_URL } from '../../request';
import { RightsWrapper } from "../../components/_utils/utils";
import { FaDownload } from 'react-icons/fa';
import _ from 'lodash';
import ReceiptView from "../../components/DocumentViews/receiptView";
const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')) : {}
const dateFormat = companyDetails && companyDetails.dateFormat ? companyDetails.dateFormat : 'DD.MM.YYYY';
const companyCurrency = companyDetails && companyDetails.companyCurrency ? companyDetails.companyCurrency : 'INR';

const formatAmount = (amount, currency) => {
    return `${currency || "INR"} ${Number(amount || 0).toFixed(2)}`;
};

const styles = {
    th: {
        padding: '12px 15px',
        textAlign: 'left',
        color: '#8c8c8c',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        fontWeight: 600
    },
    td: {
        padding: '12px 15px',
        fontSize: '13px',
        color: '#262626',
        verticalAlign: 'top'
    },
    dateRow: {
        fontSize: '11px',
        lineHeight: '1.8',
        whiteSpace: 'nowrap'
    },
    dateLabel: {
        color: '#8c8c8c',
        marginRight: '5px',
        display: 'inline-block',
        width: '60px'
    },
    label: {
        color: '#8c8c8c',
        minWidth: '140px',
        display: 'inline-block',
        fontSize: '12px'
    }
};

class StudentAccountReport extends React.Component {
    state = {
        value: "",
        suggestions: [],
        info: null,
        loading: false,
        claimDeskRights: {},
        showAccountPaymentDrawar: false,
        recordId: null,
        branchPlan: {},
    };

    loadUserRights = async () => {
        let { userRights } = await Request.loadUserRights()
        this.setState({ claimDeskRights: userRights.ClaimDesk })
    }

    componentDidMount() {
        this._isMounted = true;
        this.loadUserRights();
        this.loadBranchPlan();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue,
        });
    };

    onSuggestionsFetchRequested = async ({ value }) => {
        try {
            this.setState({ value });

            const response = await Request.handleSearchStudent({
                searchField: value,
                results: 300,
            });

            const suggestions =
                (response.data || []).map((student) => ({
                    id: student._id,
                    text: `${student.id || ""} - ${student.studentName || ""} - ${student.dateOfBirth
                        ? moment(student.dateOfBirth).format("DD/MM/YYYY")
                        : ""
                        } `,
                }));

            if (this._isMounted) {
                this.setState({ suggestions });
            }
        } catch (err) {
            console.log(err);
        }
    };

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: [],
        });
    };

    getSuggestionValue = (suggestion) => suggestion.text;

    renderSuggestion = (suggestion) => (
        <div>
            {suggestion.text}
        </div>
    );

    onSuggestionSelected = async (event, { suggestion }) => {
        try {
            this.setState({
                loading: true,
                value: suggestion.text,
            });
            const response = await Request.getInquiry(suggestion.id);

            this.setState({
                info: response.doc,
                loading: false,
            });
        } catch (err) {
            this.setState({
                loading: false,
            });
        }
    };

    showPaymentDrawer = async (receiptNumber) => {
        const response = await Request.getAccountPaymentDetailByReceipt({ id: receiptNumber });
        if (response && response.success) {
            this.setState({
                showAccountPaymentDrawar: true,
                recordId: response.doc._id
            });
        } else {
            notification.error({
                message: 'Receipt Not Found'
            })
        }
    }

    loadBranchPlan = async () => {
        let response = await Request.getBranchDetails();
        if (response && response.doc && response.doc.planDetails && response.doc.planDetails.planCommission && response.doc.planDetails.planCommissionType) {
            this.setState({ branchPlan: { commission: response.doc.planDetails.planCommission, commissionType: response.doc.planDetails.planCommissionType } });
        }
    }

    closeDocument = () => {
        this.setState({ showAccountPaymentDrawar: false });
    }

    render() {
        const { value, suggestions, info, loading, showAccountPaymentDrawar, recordId, branchPlan } = this.state;
        const { claimDeskRights } = this.state;

        const inputProps = {
            placeholder: "Search Student by Name, Mobile, Email, DOB, UCI",
            value,
            onChange: this.onChange,
        };

        const rowStyle = {
            display: "grid",
            // 8 columns ke liye dynamic spacing allocation
            gridTemplateColumns: "1.2fr 1.5fr 1fr 1.8fr 1.2fr 1fr 1.2fr 0.8fr",
            alignItems: "center",
            columnGap: "15px", // Spacing badha di taaki columns aapas me chipke na
            padding: "8px 0",  // MarginBottom ki jagah vertical padding use karna row layout me better hota hai
            fontSize: "13px",
        };

        const branchRowStyle = {
            display: "grid",
            // 6 columns ke liye optimized fractional allocation
            gridTemplateColumns: "1.5fr 2.5fr 2fr 1.5fr 1.5fr 1fr",
            alignItems: "center",
            columnGap: "20px", // Proper breathing space ke liye gap thoda aur badhaya
            padding: "10px 0",  // Thodi clean vertical padding
            fontSize: "13px",
            width: "100%",      // Ensure karo ki grid poori width cover kare
        };

        return (
            <PageHeaderWrapper title="Student Account Report">
                {
                    showAccountPaymentDrawar ?
                        <ReceiptView recordId={recordId} onClose={this.closeDocument} />
                        : null
                }
                <Card>
                    <Autosuggest
                        suggestions={suggestions}
                        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                        getSuggestionValue={this.getSuggestionValue}
                        renderSuggestion={this.renderSuggestion}
                        onSuggestionSelected={this.onSuggestionSelected}
                        inputProps={inputProps}
                    />
                </Card>

                <br />

                <Card>
                    <Spin spinning={loading}>
                        {info ? (
                            <div style={{ padding: '24px', background: '#fff', fontFamily: 'monospace, sans-serif', color: '#000' }}>

                                {/* 1. Student / University Details Section */}
                                <div style={{ marginBottom: '32px', fontSize: '14px', lineHeight: '1.8' }}>
                                    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                                        <h2 style={{ margin: 0, fontSize: '22px', fontWeight: 'bold' }}>
                                            {info.studentName ? info.studentName : "-"}
                                        </h2>
                                    </div>
                                    <div>
                                        <b>University:</b> {
                                            info.visaDesk && info.visaDesk.selectedCourse && info.visaDesk.selectedCourse.universityInstitutionName
                                                ? info.visaDesk.selectedCourse.universityInstitutionName
                                                : "-"
                                        }
                                    </div>
                                    <div>
                                        <b>Course:</b> {
                                            info.visaDesk && info.visaDesk.selectedCourse && info.visaDesk.selectedCourse.courseName
                                                ? info.visaDesk.selectedCourse.courseName
                                                : "-"
                                        }
                                    </div>
                                    <div>
                                        <b>Joining Intake:</b> {
                                            (info.visaDesk && info.visaDesk.courseStartDate) || info.intake
                                                ? moment(info.visaDesk && info.visaDesk.courseStartDate ? info.visaDesk.courseStartDate : info.intake).format("MMM YYYY")
                                                : "-"
                                        }
                                    </div>
                                    <div>
                                        <b>Branch:</b> {
                                            info.studentBranchId && info.studentBranchId.branchName
                                                ? info.studentBranchId.branchName
                                                : "-"
                                        }
                                    </div>
                                </div>

                                {/* 2. Consultancy Account Section */}
                                <div style={{ marginBottom: '32px' }}>
                                    <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px', borderBottom: '1px solid #000', paddingBottom: '4px' }}>
                                        Consultancy Account: Total Outstanding Amount ({info.registrationDesk ? info.registrationDesk.total : 0})
                                    </h3>

                                    <div style={{ paddingLeft: '10px' }}>
                                        {info.accountPaymentDetails ? (
                                            <>
                                                {/* Initial Consultancy Fee Entry */}
                                                <div style={{ display: 'flex', marginBottom: '8px', fontSize: '13px' }}>
                                                    <span style={{ width: '40px' }}>1)</span>
                                                    <span style={{ width: '120px' }}>
                                                        {info.moveDeskDate && info.moveDeskDate.moveToRegistrationDesk
                                                            ? moment(info.moveDeskDate.moveToRegistrationDesk).format(dateFormat)
                                                            : 'N/A'}
                                                    </span>
                                                    <span style={{ width: '100px' }}>
                                                        {info.registrationDesk && info.registrationDesk.total ? info.registrationDesk.total : '0'}
                                                    </span>
                                                    <span style={{ width: '150px' }}>Initial Charge</span>
                                                    <span>-</span>
                                                </div>

                                                {/* Payment History Entries */}
                                                {info.accountPaymentDetails.length > 0 ? (
                                                    info.accountPaymentDetails.map((payment, index) => (
                                                        <div key={index} style={{ display: 'flex', marginBottom: '8px', fontSize: '13px' }}>
                                                            <span style={{ width: '40px' }}>{index + 2})</span>
                                                            <span style={{ width: '120px' }}>{moment(payment.dateOfReciept).format(dateFormat)}</span>
                                                            <span style={{ width: '100px' }}>{formatAmount(payment.paid, companyCurrency)}</span>
                                                            <span style={{ width: '150px' }}>
                                                                {payment.paymentType} {payment.receipt ? `(#${payment.receipt})` : ''}
                                                            </span>
                                                            {
                                                                payment.receipt ? (
                                                                    <span>
                                                                        <a
                                                                            onClick={() => this.showPaymentDrawer(payment.receipt)}
                                                                            style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                                        >
                                                                            View
                                                                        </a>
                                                                    </span>
                                                                ) : (
                                                                    payment.paymentType === "Discount" &&
                                                                        payment.discountFile ? (
                                                                        <span>
                                                                            <a
                                                                                href={`${MEDIA_URL}${payment.discountFile[0].url} `}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ textDecoration: "underline" }}
                                                                            >
                                                                                View
                                                                            </a>
                                                                        </span>
                                                                    ) : (
                                                                        <span>-</span>
                                                                    )
                                                                )
                                                            }

                                                        </div>
                                                    ))
                                                ) : (
                                                    <div style={{ fontStyle: 'italic', color: '#555', fontSize: '13px', paddingLeft: '40px' }}>
                                                        {info.registrationDesk && info.registrationDesk.mode
                                                            ? `Payment Mode: ${info.registrationDesk.mode} `
                                                            : 'No payment transactions found'}
                                                    </div>
                                                )}
                                            </>
                                        ) : (
                                            <div style={{ fontSize: '13px' }}>Loading Ledger Details...</div>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px', borderBottom: '1px solid #000', paddingBottom: '4px' }}>
                                        Commission Account: Total Amount Outstanding (Currency + {companyCurrency})
                                    </h3>
                                    <div style={{ paddingLeft: '10px' }}>
                                        {
                                            (() => {
                                                let nextInvoiceGenerationDates = info && info.nextInvoiceGenerationDates ? info.nextInvoiceGenerationDates : [];
                                                let generatedInvoices = info && info.generatedInvoices ? info.generatedInvoices : [];

                                                // Function to compute exact status
                                                const getStatus = (invoice) => {
                                                    if (invoice.uploaded) {
                                                        return invoice.invoiceStatus || 'Uploaded';
                                                    }
                                                    let invNo = invoice.invoiceGeneratedNumber || invoice.cpInvoiceNumber;
                                                    let matchingInvs = _.filter(generatedInvoices, (item) => item.invoiceNumber === invNo);
                                                    let genInv = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : null;

                                                    if (invoice.invoiceGenerated && genInv) {
                                                        let genStatus = genInv.invoiceStatus || 'Generated';
                                                        let dbStatus = invoice.invoiceStatus || 'Pending';
                                                        
                                                        const getStatusWeight = (s) => {
                                                            const st = (s || '').toLowerCase().trim();
                                                            if (['cleared', 'paid by uni', 'completed'].includes(st)) return 4;
                                                            if (st === 'approved by uni') return 3;
                                                            if (st === 'submitted to uni') return 2;
                                                            if (st === 'generated') return 1;
                                                            return 0;
                                                        };
                                                        
                                                        return getStatusWeight(dbStatus) >= getStatusWeight(genStatus) ? dbStatus : genStatus;
                                                    }
                                                    return invoice.invoiceStatus || 'Pending';
                                                };

                                                // Pending/Outstanding: Exclude Cleared & Paid by Uni
                                                const pendingInvoices = nextInvoiceGenerationDates.filter(function (invoice) {
                                                    let st = getStatus(invoice).toString().trim().toLowerCase();
                                                    return st !== "cleared" && st !== "paid by uni";
                                                });

                                                if (pendingInvoices.length === 0) {
                                                    return (
                                                        <div style={{ fontStyle: "italic", color: "#555", fontSize: "13px", paddingLeft: "10px" }}>
                                                            No outstanding commission invoices found.
                                                        </div>
                                                    );
                                                }

                                                return pendingInvoices.map((invoice, index) => {
                                                    let invNumber = invoice.invoiceGeneratedNumber || invoice.cpInvoiceNumber;
                                                    let matchingInvs = _.filter(generatedInvoices, (item) => item.invoiceNumber === invNumber);
                                                    let generatedInvoice = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : {};
                                                    let invoiceId = invoice._id;
                                                    let invoiceDetail = generatedInvoice.invoices || [];

                                                    let finalInvoiceDetail = _.find(invoiceDetail, (item) => String(item.invoiceGeneratedRecordId) === String(invoiceId)) || {};

                                                    let commissionTotal = finalInvoiceDetail.commissionTotal || invoice.commReceived || 0;
                                                    let currency = finalInvoiceDetail.currency || (info.visaDesk && info.visaDesk.selectedCourse && info.visaDesk.selectedCourse.currency) || "INR";

                                                    const currencyRate = finalInvoiceDetail.conversionRate
                                                        ? finalInvoiceDetail.conversionRate
                                                        : (info.finalCountryDetails && info.finalCountryDetails.currencyRate ? info.finalCountryDetails.currencyRate : 1);

                                                    if (claimDeskRights && claimDeskRights.viewByBranch) {
                                                        const branchPlan = this.state.branchPlan;
                                                        if (branchPlan.commissionType === 'Flat') {
                                                            commissionTotal = Number(branchPlan.commission) || 0;
                                                        } else if (branchPlan.commissionType === 'Percentage') {
                                                            const percent = Number(branchPlan.commission) || 0;
                                                            commissionTotal = (commissionTotal * percent) / 100;
                                                        }
                                                    }

                                                    let convertedAmount = finalInvoiceDetail.commissionTotalConverted;
                                                    if (!convertedAmount || (claimDeskRights && claimDeskRights.viewByBranch)) {
                                                        convertedAmount = commissionTotal * currencyRate;
                                                    }

                                                    let currentStatusText = getStatus(invoice);

                                                    return (
                                                        <div key={index} style={rowStyle}>
                                                            <span>
                                                                {invoice.generationDate ? moment(invoice.generationDate).format(dateFormat) : "NA"}
                                                            </span>

                                                            <span>
                                                                {formatAmount(commissionTotal, currency)}
                                                            </span>

                                                            <span>
                                                                {currencyRate}
                                                            </span>

                                                            <span>
                                                                {formatAmount(convertedAmount, companyCurrency)}
                                                            </span>

                                                            {claimDeskRights && !claimDeskRights.viewByBranch && (
                                                                <span>
                                                                    {generatedInvoice.invoiceNumber || invNumber || "-"}
                                                                </span>
                                                            )}

                                                            <span>
                                                                {invoice.invoiceNo ? "T" + invoice.invoiceNo : "-"}
                                                            </span>

                                                            <span style={{ color: "#f59e0b" }}>
                                                                {currentStatusText}
                                                            </span>

                                                            {claimDeskRights && !claimDeskRights.viewByBranch && (
                                                                <span>
                                                                    {generatedInvoice && generatedInvoice.invoiceUrl ? (
                                                                        <a
                                                                            href={MEDIA_URL + generatedInvoice.invoiceUrl}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            style={{ textDecoration: "underline" }}
                                                                        >
                                                                            View
                                                                        </a>
                                                                    ) : (
                                                                        "-"
                                                                    )}
                                                                </span>
                                                            )}
                                                        </div>
                                                    );
                                                });
                                            })()
                                        }
                                    </div>
                                </div>
                                {
                                    claimDeskRights && !claimDeskRights.viewByBranch && (
                                        <div style={{ marginTop: '15px' }}>
                                            <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px', borderBottom: '1px solid #000', paddingBottom: '4px' }}>
                                                Funds Received
                                            </h3>
                                            <div style={{ paddingLeft: '10px' }}>
                                                {
                                                    (() => {
                                                        let nextInvoiceGenerationDates = info && info.nextInvoiceGenerationDates ? info.nextInvoiceGenerationDates : [];
                                                        let generatedInvoices = info && info.generatedInvoices ? info.generatedInvoices : [];

                                                        const getStatus = (invoice) => {
                                                            if (invoice.uploaded) {
                                                                return invoice.invoiceStatus || 'Uploaded';
                                                            }
                                                            let invNo = invoice.invoiceGeneratedNumber || invoice.cpInvoiceNumber;
                                                            let matchingInvs = _.filter(generatedInvoices, (item) => item.invoiceNumber === invNo);
                                                            let genInv = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : null;

                                                            if (invoice.invoiceGenerated && genInv) {
                                                                let genStatus = genInv.invoiceStatus || 'Generated';
                                                                let dbStatus = invoice.invoiceStatus || 'Pending';
                                                                
                                                                const getStatusWeight = (s) => {
                                                                    const st = (s || '').toLowerCase().trim();
                                                                    if (['cleared', 'paid by uni', 'completed'].includes(st)) return 4;
                                                                    if (st === 'approved by uni') return 3;
                                                                    if (st === 'submitted to uni') return 2;
                                                                    if (st === 'generated') return 1;
                                                                    return 0;
                                                                };
                                                                
                                                                return getStatusWeight(dbStatus) >= getStatusWeight(genStatus) ? dbStatus : genStatus;
                                                            }
                                                            return invoice.invoiceStatus || 'Pending';
                                                        };

                                                        // Cleared: Only keep Cleared & Paid by Uni
                                                        const clearedInvoices = nextInvoiceGenerationDates.filter(function (invoice) {
                                                            let st = getStatus(invoice).toString().trim().toLowerCase();
                                                            return st === "cleared" || st === "paid by uni";
                                                        });

                                                        if (clearedInvoices.length === 0) {
                                                            return (
                                                                <div style={{ fontStyle: "italic", color: "#555", fontSize: "13px", paddingLeft: "10px" }}>
                                                                    No cleared commission invoices found.
                                                                </div>
                                                            );
                                                        }

                                                        return clearedInvoices.map((invoice, index) => {
                                                            let invNumber = invoice.invoiceGeneratedNumber || invoice.cpInvoiceNumber;
                                                            let matchingInvs = _.filter(generatedInvoices, (item) => item.invoiceNumber === invNumber);
                                                            let generatedInvoice = matchingInvs.length > 0 ? matchingInvs[matchingInvs.length - 1] : {};
                                                            let invoiceId = invoice._id;
                                                            let invoiceDetail = generatedInvoice.invoices || [];

                                                            let finalInvoiceDetail = _.find(invoiceDetail, (item) => String(item.invoiceGeneratedRecordId) === String(invoiceId)) || {};

                                                            let commissionTotal = finalInvoiceDetail.commissionTotal || invoice.commReceived || 0;
                                                            let currency = finalInvoiceDetail.currency || (info.visaDesk && info.visaDesk.selectedCourse && info.visaDesk.selectedCourse.currency) || "INR";

                                                            const currencyRate = finalInvoiceDetail.conversionRate
                                                                ? finalInvoiceDetail.conversionRate
                                                                : (info.finalCountryDetails && info.finalCountryDetails.currencyRate ? info.finalCountryDetails.currencyRate : 1);

                                                            let convertedAmount = finalInvoiceDetail.commissionTotalConverted || (commissionTotal * currencyRate);

                                                            let currentStatusText = getStatus(invoice);

                                                            return (
                                                                <div key={index} style={rowStyle}>
                                                                    <span>
                                                                        {invoice.generationDate ? moment(invoice.generationDate).format(dateFormat) : "NA"}
                                                                    </span>

                                                                    <span>
                                                                        {formatAmount(commissionTotal, currency)}
                                                                    </span>

                                                                    <span>{currencyRate}</span>

                                                                    <span>
                                                                        {formatAmount(convertedAmount, companyCurrency)}
                                                                    </span>

                                                                    <span>{generatedInvoice.invoiceNumber || invNumber || "-"}</span>

                                                                    <span>
                                                                        {invoice.invoiceNo ? "T" + invoice.invoiceNo : "-"}
                                                                    </span>

                                                                    <span style={{ color: "#16a34a" }}>
                                                                        {currentStatusText}
                                                                    </span>

                                                                    <span>
                                                                        {generatedInvoice && generatedInvoice.paymentReceipt && generatedInvoice.paymentReceipt.length > 0 ? (
                                                                            <a
                                                                                href={MEDIA_URL + generatedInvoice.paymentReceipt[0].url}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                                style={{ textDecoration: "underline" }}
                                                                            >
                                                                                View
                                                                            </a>
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            );
                                                        });
                                                    })()
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    claimDeskRights && claimDeskRights.viewByBranch && (
                                        <>
                                            <div style={{ marginTop: '15px' }}>
                                                <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '16px', borderBottom: '1px solid #000', paddingBottom: '4px' }}>
                                                    Funds Received
                                                </h3>
                                                <div style={{ paddingLeft: '10px' }}>
                                                    {
                                                        (() => {
                                                            let branchApInvoices = info && info.branchApInvoices;
                                                            return branchApInvoices.map((invoice, index) => {
                                                                if (invoice.status === "Paid") {
                                                                    return (
                                                                        <div key={index} style={branchRowStyle}>

                                                                            <span>
                                                                                {invoice.invoice_details &&
                                                                                    invoice.invoice_details.paymentDate
                                                                                    ? moment(
                                                                                        invoice.invoice_details.paymentDate.$date
                                                                                            ? invoice.invoice_details.paymentDate.$date.$numberLong
                                                                                            : invoice.invoice_details.paymentDate
                                                                                    ).format(dateFormat)
                                                                                    : "-"}
                                                                            </span>

                                                                            <span>
                                                                                {formatAmount(
                                                                                    invoice.invoice_details
                                                                                        ? invoice.invoice_details.totalAfterAdditionalDeduction
                                                                                        : 0,
                                                                                    "INR"
                                                                                )}
                                                                            </span>

                                                                            <span>
                                                                                {invoice.branchInvoiceNumber || "-"}
                                                                            </span>

                                                                            <span>
                                                                                {invoice.termNumber ? "T" + invoice.termNumber : "-"}
                                                                            </span>

                                                                            <span
                                                                                style={{
                                                                                    color: invoice.status === "Paid" ? "#16a34a" : "#f59e0b"
                                                                                }}
                                                                            >
                                                                                {invoice.status}
                                                                            </span>

                                                                            <span>
                                                                                {invoice.invoice_details &&
                                                                                    invoice.invoice_details.paymentReceipt &&
                                                                                    invoice.invoice_details.paymentReceipt.length > 0 ? (
                                                                                    <a
                                                                                        href={
                                                                                            MEDIA_URL +
                                                                                            invoice.invoice_details.paymentReceipt[0].url
                                                                                        }
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        style={{ textDecoration: "underline" }}
                                                                                    >
                                                                                        View
                                                                                    </a>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                            </span>

                                                                        </div>
                                                                    );
                                                                }
                                                            })
                                                        })()
                                                    }
                                                </div>
                                            </div>
                                        </>
                                    )
                                }

                            </div>
                        ) : (
                            <div style={{ textAlign: 'center', padding: '20px', fontFamily: 'sans-serif' }}>Select a student to view details.</div>
                        )}

                    </Spin>
                </Card>
            </PageHeaderWrapper>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    categories: global.categories,
    loading: global.buttonLoading,
    claimDeskRights: global.claimDeskRights // global state se connect kiya gaya hai
});

export default connect(mapStateToProps)(StudentAccountReport);